import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createFeatureSelector, createReducer, on } from '@ngrx/store';
import * as CheckupActions from './checkup.actions';
import { Checkup } from './checkup.model';

export const checkupsFeatureKey = 'checkups';

export interface State extends EntityState<Checkup> {
    // additional entities state properties
}

export const adapter: EntityAdapter<Checkup> = createEntityAdapter<Checkup>({
    selectId: (model: Checkup) => model.id
});

export const initialState: State = adapter.getInitialState({
    // additional entity state properties
});

const checkupReducer = createReducer(
    initialState,
    on(CheckupActions.addCheckup, (state, action) =>
        adapter.addOne(action.checkup, state)
    ),
    on(CheckupActions.upsertCheckup, (state, action) =>
        adapter.upsertOne(action.checkup, state)
    ),
    on(CheckupActions.addCheckups, (state, action) =>
        adapter.addMany(action.checkups, state)
    ),
    on(CheckupActions.upsertCheckups, (state, action) =>
        adapter.upsertMany(action.checkups, state)
    ),
    on(CheckupActions.updateCheckup, (state, action) =>
        adapter.updateOne(action.checkup, state)
    ),
    on(CheckupActions.updateCheckups, (state, action) =>
        adapter.updateMany(action.checkups, state)
    ),
    on(CheckupActions.deleteCheckup, (state, action) =>
        adapter.removeOne(action.id, state)
    ),
    on(CheckupActions.deleteCheckups, (state, action) =>
        adapter.removeMany(action.ids, state)
    ),
    on(CheckupActions.loadCheckups, (state, action) =>
        adapter.setAll(action.checkups, state)
    ),
    on(CheckupActions.clearCheckups, state => adapter.removeAll(state))
);

export function reducer(state: State | undefined, action: Action) {
    return checkupReducer(state, action);
}
const localState = createFeatureSelector<State>(checkupsFeatureKey);
export const { selectIds, selectEntities, selectAll, selectTotal } =
    adapter.getSelectors(localState);
